import React from 'react';
import { connect } from 'react-redux';
import { getDefaultIfEmpty } from '../../../helpers/Common';
import PriceVolumeTable from './PriceVolumeTable';
import DropDownNameOfFeature from './DropDownNameOfFeature';
import Footer from '../../../common/table/Footer';
import './PriceVolume.scss';
import { ChanelConfig } from '../../../../configs/GlobalConfig';
import MessageHub from '../../../../core/signalr/SignalrMessageHub';
import {
  REDUCER_NAME,
  intervalFetchPriceVolume,
  subscribeRealtimeTickPriceVolume,
  cancelfetchDataPriceVolume,
} from './reducer';

const defaultSortState = { totalMatchVolume: 'desc' };

class PriceVolume extends React.Component {
  state = {
    sortState: defaultSortState,
  };

  componentDidMount() {
    this.fetchData();
    MessageHub.subscribe(ChanelConfig.TickChanel, this.dispatchDataRealtime);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { sortState } = this.state;
    const { featureType } = this.props;
    if (
      sortState !== prevState.sortState ||
      featureType !== prevProps.featureType
    ) {
      this.fetchData();
    }
  }

  componentWillUnmount() {
    const { cancelfetchDataPriceVolume } = this.props;
    cancelfetchDataPriceVolume();
    MessageHub.unsubscribe(ChanelConfig.TickChanel, this.dispatchDataRealtime);
  }

  fetchData = () => {
    const { sortState } = this.state;
    const { intervalFetchPriceVolume, featureType } = this.props;
    intervalFetchPriceVolume(featureType, sortState);
  };

  dispatchDataRealtime = data => {
    const { subscribeRealtimeTickPriceVolume } = this.props;
    subscribeRealtimeTickPriceVolume(data);
  };

  onSort = sortState => {
    this.setState({
      sortState: getDefaultIfEmpty(sortState, defaultSortState),
    });
  };

  render() {
    return (
      <div className="price-volume d-flex flex-fill flex-column">
        <DropDownNameOfFeature />
        <div className="tab-content d-flex flex-fill flex-column h-auto">
          <div className="tab-pane active d-flex flex-fill flex-column h-auto">
            <PriceVolumeTable onSort={this.onSort} />
          </div>
          <Footer
            listTextLang={[
              {
                text: 'common.table.TABLE_FOOTER_TEXT_WITH_UNIT',
                style: {},
              },
            ]}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  featureType: state[REDUCER_NAME].featureType,
});

const mapDispatchToProps = {
  intervalFetchPriceVolume,
  subscribeRealtimeTickPriceVolume,
  cancelfetchDataPriceVolume,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PriceVolume);
